import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import Panel from 'wonderbly-components/lib/Panel';
import RichText from '../../Prismic/RichText';
import { optimiseImage } from 'src/common/utils/prismic-image';
import LookInside from '../../LookInside';
import Price from '../../Price';
import './addon.scss';

const AddOn = props => (
  <label
    htmlFor={`addon-option-${props.value}`}
    className={cx('addon', {
      'addon--large': props.large,
      'addon--selected': props.selected,
      'addon--has-look-inside': !isEmpty(props.lookInside),
    })}>
    <Panel border="shadow">
      <input
        type="checkbox"
        id={`addon-option-${props.value}`}
        name="components[][id]"
        checked={props.selected}
        onChange={props.handleOnChange}
      />

      <div className="addon-image">
        <img
          src={optimiseImage(props.image.url, {
            auto: 'format,compress',
            w: props.image.dimensions.width,
          })}
          alt={props.image.alt}
          width={props.image.dimensions.width / 2}
        />
      </div>
      <div className="addon-wrapper">
        <div className="addon-checkbox" />
        <div className="addon-content">
          <h4 className="addon-title">
            {props.title}{' '}
            <Price
              className="addon-price"
              price={props.price}
              savings={props.savings}
              priceString={'+ %{price}'}
              savingPriceString={props.savingPriceString}
            />
          </h4>
          <RichText fields={props.description} className="addon-description" />
        </div>
      </div>
    </Panel>
    {!isEmpty(props.lookInside) &&
      <LookInside
        for="addon"
        {...props.lookInside}
        price={props.price}
        savings={props.savings}
        priceString={'+ %{price}'}
        savingPriceString={props.savingPriceString}
        onLookInsideMain={props.handleLookInsideMain}
        onLookInsideCancel={props.handleLookInsideCancel}
      />
    }
  </label>
);

AddOn.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  large: PropTypes.bool.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
    }).isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.array.isRequired,
  price: PropTypes.object.isRequired,
  priceString: PropTypes.string,
  savings: PropTypes.object,
  savingPriceString: PropTypes.string,
  lookInside: PropTypes.object,
  handleLookInsideMain: PropTypes.func,
  handleLookInsideCancel: PropTypes.func,
};

export default AddOn;



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddOns/AddOn/AddOn.js